import * as React from 'react'
import {Alert} from '@frontrow/console/src/components/ui/alert'

import {type SchoolBatchUpdateResponseT} from '@frontrow/console/src/models/school-batch-update'
import Wrapper from '@frontrow/console/src/components/pages/bulk-edit-school-configuration/wrapper'
import {alertWrapper} from '@frontrow/console/src/components/pages/bulk-edit-school-configuration/bulk-edit-school-configuration.module.scss'

type Props = {
  batchUpdateResponse: SchoolBatchUpdateResponseT
}

export function BatchUpdateResponseNotification(props: Props): React.ReactElement {
  const {batchUpdateResponse} = props
  const {errors, results} = batchUpdateResponse

  return (
    <Wrapper>
      {errors.length > 0 ? (
        <div className={alertWrapper}>
          <Alert type="danger">{errors.length} schools could not be configured.</Alert>
        </div>
      ) : null}
      {results.length > 0 ? (
        <div className={alertWrapper}>
          <Alert type="success">{results.length} schools have been successfully configured.</Alert>
        </div>
      ) : null}
    </Wrapper>
  )
}
